const place = {
  items_center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  items_stretch: {
    alignItems: 'stretch',
    justifyContent: 'stretch',
  },
  items_start: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  items_end: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  items_between: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  items_around: {
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  items_evenly: {
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
};

export default place;
